<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :width="800"
    :class="$style.modalOrderPaid"
    @cancel="() => $emit('handleOrderPaid', false)"
  >
    <h2 style="text-align: center">
      {{ row.payment_number }}
    </h2>
    <div class="mt-4">
      <a-table
        :columns="columns"
        :loading="loading"
        :data-source="list"
        :pagination="false"
        :scroll="{ x: 1300 }"
      >
        <template slot="invoice_number" slot-scope="text">
          <div style="display: flex; align-items: flex-start; gap: 8px; min-width: 0;">
            <a-button
              v-if="text"
              type="link"
              style="padding: 0; flex-shrink: 0;"
              @click="copyToClipboard('Invoice Number', text)"
            >
              <a-icon type="copy" />
            </a-button>
            <span style="word-wrap: break-word; word-break: break-all; flex: 1;">{{ text || '-' }}</span>
          </div>
        </template>
        <template slot="order_outstanding_amount" slot-scope="text">
          <div style="display: flex; align-items: center; gap: 8px;">
            <a-button
              v-if="text"
              type="link"
              style="padding: 0; flex-shrink: 0;"
              @click="copyToClipboard('Outstanding Amount', text)"
            >
              <a-icon type="copy" />
            </a-button>
            <span>{{ currency }} {{ toCurrency(text) }}</span>
          </div>
        </template>
        <template slot="payment_amount" slot-scope="text">
          <div style="display: flex; align-items: center; gap: 8px;">
            <a-button
              v-if="text"
              type="link"
              style="padding: 0; flex-shrink: 0;"
              @click="copyToClipboard('Payment Amount', text)"
            >
              <a-icon type="copy" />
            </a-button>
            <span>{{ currency }} {{ toCurrency(text) }}</span>
          </div>
        </template>
        <template slot="calc_outstanding_amount" slot-scope="text">
          <div style="display: flex; align-items: center; gap: 8px;">
            <a-button
              v-if="text"
              type="link"
              style="padding: 0; flex-shrink: 0;"
              @click="copyToClipboard('Remaining Outstanding', text)"
            >
              <a-icon type="copy" />
            </a-button>
            <span>{{ currency }} {{ toCurrency(text) }}</span>
          </div>
        </template>
      </a-table>
      <!-- {{ pages }}
      <Pagination
        class="text-right"
        :total="paginations.total_items"
        :page-size="paginations.size"
        :default-page="pages"
        :total-length-per-page="list?.length"
        @changePage="changePageTagihan"
      /> -->
    </div>
  </a-modal>
</template>

<script>
import historyPayment from '../composables/historyPayment'
import { h } from 'vue'
// import Pagination from '@/components/Pagination/index.vue'

export default {
  name: 'ModalOrderPaid',
  // components: {
  // Pagination,
  // },
  props: ['list', 'loading', 'paginations', 'row', 'visible'],
  setup() {
    const { changePageTagihan, pages, listTagihan } = historyPayment()

    return {
      changePageTagihan,
      pages,
      listTagihan,
    }
  },
  data() {
    return {}
  },
  computed: {
    currency() {
      const businessId = this.$route.query.business_id || (this.row && this.row.business_id) || Object.keys(this.$store.getters['user/businessListObjectByKey'])[0]
      return this.$store.getters['user/getCurrentBusinessCurrencyCode'](businessId) || 'IDR'
    },
    columns() {
      return [
        {
          title: this.$t('paymentHistory.column_order_number'),
          dataIndex: 'order_number',
          key: 'order_number',
          fixed: 'left',
          width: 180,
        },
        {
          title: this.$t('paymentHistory.export_order_date'),
          dataIndex: 'created_at',
          key: 'created_at',
          ellipsis: true,
          customRender: value => {
            const time =
              value && this.$moment(value).format('DD MMM YYYY HH:mm')
            if (time) return time
            else return '-'
          },
        },
        {
          title: this.$t('paymentHistory.column_invoice_number'),
          dataIndex: 'invoice_number',
          key: 'invoice_number',
          scopedSlots: {
            customRender: 'invoice_number',
          },
        },
        {
          title: this.$t('paymentHistory.column_due_date'),
          dataIndex: 'expired_at',
          key: 'expired_at',
          ellipsis: true,
          customRender: value => {
            const time =
              value && this.$moment(value).format('DD MMM YYYY HH:mm')
            if (time) return time
            else return '-'
          },
        },
        {
          title: this.$t('paymentHistory.column_outstanding'),
          dataIndex: 'order_outstanding_amount',
          key: 'order_outstanding_amount',
          ellipsis: true,
          scopedSlots: {
            customRender: 'order_outstanding_amount',
          },
        },
        {
          title: this.$t('paymentHistory.column_payment'),
          dataIndex: 'payment_amount',
          key: 'payment_amount',
          ellipsis: true,
          scopedSlots: {
            customRender: 'payment_amount',
          },
        },
        {
          title: this.$t('paymentHistory.column_remaining_outstanding'),
          dataIndex: 'calc_outstanding_amount',
          key: 'calc_outstanding_amount',
          ellipsis: true,
          scopedSlots: {
            customRender: 'calc_outstanding_amount',
          },
        },
        {
          title: this.$t('paymentHistory.column_status'),
          dataIndex: 'status',
          key: 'status',
          fixed: 'right',
          width: 150,
        },
      ]
    },
  },
  methods: {
    toCurrency(value) {
      return `${Intl.NumberFormat('en-US').format(value || 0)}`
    },
    copyToClipboard(type, val) {
      navigator.clipboard.writeText(val)
      this.$notification.success({
        message: this.$t('paymentHistory.copied_success', { type, value: val }),
      })
    },
    // onChangePage(pagination, filters, sorter) {
    //   console.log({ pagination })
    //   const pager = { ...this.pagination };
    //   pager.current = pagination.current;
    //   this.pages = pager;
    // },
  },
}
</script>

<style lang="scss" module>
@import '../style.module.scss';
</style>
